import React, { createContext, useContext, useMemo } from "react";

const GuidedModeContext = createContext(null);

/**
 * Application-wide guided tour mode — components may observe this to suspend
 * auto-dismiss, keep dialogs open, etc. The Tour Engine sets this while active.
 */
export function GuidedModeProvider({
  children,
  isActive = false,
  stepId = null,
  stepPhase = null,
  scopes = [],
}) {
  const value = useMemo(
    () => ({
      isActive,
      stepId,
      stepPhase,
      scopes,
      hasScope: (scope) => isActive && scopes.includes(scope),
    }),
    [isActive, stepId, stepPhase, scopes],
  );

  return (
    <GuidedModeContext.Provider value={value}>{children}</GuidedModeContext.Provider>
  );
}

export function useGuidedMode() {
  const context = useContext(GuidedModeContext);
  if (!context) {
    throw new Error("useGuidedMode must be used within GuidedModeProvider");
  }
  return context;
}

/**
 * @returns {import('./GuidedModeContext').GuidedModeValue | null}
 */
export function useGuidedModeOptional() {
  return useContext(GuidedModeContext);
}
